module.exports = __webpack_public_path__ + "img/noData.9f701fe7.png";